module.exports = __webpack_public_path__ + "img/Cube_qui_saute.59a9dcd7.gif";